module.exports = __webpack_public_path__ + "img/img4.fb7c6937.png";